export default __webpack_public_path__ + "static/media/gologo.8da79ffa.png";